import { render, staticRenderFns } from "./ConstructAResponse.vue?vue&type=template&id=63bf7a43&scoped=true&"
import script from "./ConstructAResponse.vue?vue&type=script&lang=ts&"
export * from "./ConstructAResponse.vue?vue&type=script&lang=ts&"
import style0 from "./ConstructAResponse.vue?vue&type=style&index=0&id=63bf7a43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bf7a43",
  null
  
)

export default component.exports